import React, { useRef, useEffect } from 'react';
import { gsap } from 'gsap';
import './Input.css';

const Input = ({
  type = "text",
  placeholder,
  value,
  onChange,
  errorMessage,
  label,
  disabled
}) => {
  const inputRef = useRef(null);

  const handleFocus = () => {
    gsap.fromTo(
      inputRef.current,
      { boxShadow: '0 0 0 rgba(0,0,0,0)' },
      { boxShadow: '0 0 4px var(--color-accent)', duration: 0.25, ease: 'power2.out' }
    );
  };

  const handleBlur = () => {
    gsap.to(inputRef.current, { boxShadow: '0 0 0 rgba(0,0,0,0)', duration: 0.25 });
  };

  // Pequena animação quando o erro aparece
  useEffect(() => {
    if (errorMessage && inputRef.current) {
      gsap.fromTo(
        inputRef.current,
        { x: -3 },
        { x: 0, duration: 0.15, ease: 'power1.inOut', repeat: 2, yoyo: true }
      );
    }
  }, [errorMessage]);

const hasValue = typeof value === 'string' && value.trim().length > 0;

  return (
    <div className="input-container">
      {label && <label className="input-label">{label}</label>}
      <input
        ref={inputRef}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        className={`form-control ${disabled ? 'disabled' : ''} ${errorMessage ? 'error' : ''} ${hasValue ? 'filled' : ''}`}
        disabled={disabled}
      />
      {errorMessage && <p className="error-message">{errorMessage}</p>}
    </div>
  );
};

export default Input;
